export var componentsLocales = {
  closeButtonAriaLabel: 'Закрыть уведомление'
};